export default [
  'Argentina',
  'Australia',
  'Plurinational State of Bolivia',
  'Brazil',
  'Canada',
  'Chile',
  "People's Republic of China",
  'Colombia',
  'Democratic Republic of The Congo',
  'Ecuador',
  'European Union',
  'Finland',
  'France',
  'Germany',
  'India',
  'Indonesia',
  'Japan',
  'Mexico',
  'New Zealand',
  'Peru',
  'Philippines',
  'South Africa',
  'Spain',
  'United Kingdom',
  'United States',
];
